/* eslint-disable max-len */
export default {
  OPEN_BOP_POPUP: 'OPEN_BOP_POPUP',
  CLOSE_BOP_POPUP: 'CLOSE_BOP_POPUP',
  SHOW_VIDEO: 'SHOW_VIDEO',
  AD_CLICK: 'AD_CLICK',
  ADD_TO_FAVOURITES: 'ADD_TO_FAVOURITES',
  ADD_REVIEW: 'ADD_REVIEW',
  REMOVE_FROM_FAVOURITES: 'REMOVE_FROM_FAVOURITES',
  ERROR: 'ERROR',
  DELIVERY_MONTH_SELECTED: 'DELIVERY_MONTH_SELECTED',
  DELIVERY_DAY_SELECTED: 'DELIVERY_DAY_SELECTED',
  DELIVERY_SLOT_SELECTED: 'DELIVERY_SLOT_SELECTED',
  DELIVERY_CALENDAR_DISPLAYED: 'DELIVERY_CALENDAR_DISPLAYED',
  ONE_PAGE_EVENT_SCROLL: 'ONE_PAGE_EVENT_SCROLL',
  FREE_DISCOUNT_CLUB_ADVERT_CLICKED: 'FREE_DISCOUNT_CLUB_ADVERT_CLICKED',
  NORMAL_LOGIN_ATTEMPT: 'NORMAL_LOGIN_ATTEMPT',
  FACEBOOK_LOGIN_ATTEMPT: 'FACEBOOK_LOGIN_ATTEMPT',
  LOGIN_FAIL: 'LOGIN_FAIL',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  PAYPAL_LOGIN_ATTEMPT: 'PAYPAL_LOGIN_ATTEMPT',
  SSO_LOGIN_ATTEMPT: 'SSO_LOGIN_ATTEMPT',
  FACEBOOK_REGISTRATION_ATTEMPT: 'FACEBOOK_REGISTRATION_ATTEMPT',
  PAYPAL_REGISTRATION_ATTEMPT: 'PAYPAL_REGISTRATION_ATTEMPT',
  SSO_REGISTRATION_ATTEMPT: 'SSO_REGISTRATION_ATTEMPT',
  SSO_REGISTRATION_FAILED: 'SSO_REGISTRATION_FAILED',
  LINKED_PAYPAL_ACCOUNT: 'LINKED_PAYPAL_ACCOUNT',
  UNLINKED_PAYPAL_ACCOUNT: 'UNLINKED_PAYPAL_ACCOUNT',
  REGISTRATION_CUSTOMER_EXISTS: 'REGISTRATION_CUSTOMER_EXISTS',
  REGISTRATION_FORM_ERRORS: 'REGISTRATION_FORM_ERRORS',
  REGISTRATION_SUCCESSFUL: 'REGISTRATION_SUCCESSFUL',
  REGISTRATION_MARKETING_OPTION_UNCHECKED: 'REGISTRATION_MARKETING_OPTION_UNCHECKED',
  REGISTRATION_POSTCODE_OUT_OF_AREA: 'REGISTRATION_POSTCODE_OUT_OF_AREA',
  CHECKOUT_CONTINUED_WITHOUT_GIFT: 'CHECKOUT_CONTINUED_WITHOUT_GIFT',
  CHECKOUT_CONTINUED_WITH_GIFT: 'CHECKOUT_CONTINUED_WITH_GIFT',
  CHECKOUT_UPDATED_DELIVERY_INSTRUCTIONS: 'CHECKOUT_UPDATED_DELIVERY_INSTRUCTIONS',
  APP_BANNER_CLOSED: 'APP_BANNER_CLOSED',
  APP_BANNER_REDIRECT_TO_STORE: 'APP_BANNER_REDIRECT_TO_STORE',
  ULP_BANNER_CLOSED: 'ULP_BANNER_CLOSED',
  COUPONS_ENTRY_FROM_MENU: 'COUPONS_ENTRY_FROM_MENU',
  COUPONS_ENTRY_FROM_BOP: 'COUPONS_ENTRY_FROM_BOP',
  COUPONS_ENTRY_FROM_INTRO_POPUP: 'COUPONS_ENTRY_FROM_INTRO_POPUP',
  COUPONS_ENTRY_FROM_HOMEPAGE_COUPONS_INFO: 'COUPONS_ENTRY_FROM_HOMEPAGE_COUPONS_INFO',
  COUPONS_INTRODUCTION_POPUP_DISPLAYED: 'COUPONS_INTRODUCTION_POPUP_DISPLAYED',
  COUPON_APPLIED: 'COUPON_APPLIED',
  COUPON_CANCELLED: 'COUPON_CANCELLED',
  PERSONALISATION_BANNER_DISPLAYED: 'PERSONALISATION_BANNER_DISPLAYED',
  PERSONALISATION_BANNER_CLOSED: 'PERSONALISATION_BANNER_CLOSED',
  PERSONALISATION_BANNER_CLICKED: 'PERSONALISATION_BANNER_CLICKED',
  PRODUCT_ADDED_TO_SHOPPING_LIST: 'PRODUCT_ADDED_TO_SHOPPING_LIST',
  PAYMENT_METHOD_ADDED: 'PAYMENT_METHOD_ADDED',
  PAYMENT_METHOD_FREE_TOKEN: 'PAYMENT_METHOD_FREE_TOKEN',
  APPLE_PAY_PAYMENT_ERROR: 'APPLE_PAY_PAYMENT_ERROR',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  RECIPE_FINDER_SEARCH: 'RECIPE_FINDER_SEARCH',
  REGULAR_REGISTRATION_ATTEMPT: 'REGULAR_REGISTRATION_ATTEMPT',
  VOUCHER_ADD: 'VOUCHER_ADD',
  VOUCHER_REMOVE: 'VOUCHER_REMOVE',
  VOUCHER_ERROR: 'VOUCHER_ERROR',
  RELATED_SEARCH_SUGGESTION_SELECTED: 'RELATED_SEARCH_SUGGESTION_SELECTED',
  RELATED_SEARCH_NON_CONVERTED_RIBBON_DISPLAYED: 'RELATED_SEARCH_NON_CONVERTED_RIBBON_DISPLAYED',
  RELATED_SEARCH_CONVERTED_RIBBON_DISPLAYED: 'RELATED_SEARCH_CONVERTED_RIBBON_DISPLAYED',
  RELATED_SEARCH_RIBBON_SELECTED: 'RELATED_SEARCH_RIBBON_SELECTED',
  RELATED_CATEGORIES_RIBBON_SELECTED: 'RELATED_CATEGORIES_RIBBON_SELECTED',
  BROWSER_NO_JS: 'BROWSER_NO_JS',
  BROWSER_NOT_SUPPORTED: 'BROWSER_NOT_SUPPORTED',
  MULTI_SEARCH_CLICKED: 'MULTI_SEARCH_CLICKED',
  MULTI_SEARCH_CLEAR_LIST_CLICKED: 'MULTI_SEARCH_CLEAR_LIST_CLICKED',
  MULTI_SEARCH_EDIT_LIST_CLICKED: 'MULTI_SEARCH_EDIT_LIST_CLICKED',
  MULTI_SEARCH_FORM_SUBMIT: 'MULTI_SEARCH_FORM_SUBMIT',
  MULTI_SEARCH_CAROUSEL_SCROLLED: 'MULTI_SEARCH_CAROUSEL_SCROLLED',
  SLOT_SUB_HOME_PAGE_FROM_TAB: 'SLOT_SUB_HOME_PAGE_FROM_TAB',
  SLOT_SUB_HOME_PAGE_FROM_MY_ACCOUNT: 'SLOT_SUB_HOME_PAGE_FROM_MY_ACCOUNT',
  SLOT_SUB_HOME_PAGE_FROM_ORDERS: 'SLOT_SUB_HOME_PAGE_FROM_ORDERS',
  SLOT_SUB_HOME_PAGE_FROM_SHOPPING_LISTS: 'SLOT_SUB_HOME_PAGE_FROM_SHOPPING_LISTS',
  SLOT_SUB_HOME_PAGE_FROM_FAVOURITES: 'SLOT_SUB_HOME_PAGE_FROM_FAVOURITES',
  SLOT_SUB_HOME_PAGE_FROM_ACCOUNT_SETTINGS: 'SLOT_SUB_HOME_PAGE_FROM_ACCOUNT_SETTINGS',
  SLOT_SUB_HOME_PAGE_FROM_MOBILE_NAV: 'SLOT_SUB_HOME_PAGE_FROM_MOBILE_NAV',
  SLOT_SUB_HOME_PAGE_FROM_OTHER: 'SLOT_SUB_HOME_PAGE_FROM_OTHER',
  SLOT_SUB_TERMS_AND_CONDITIONS_CLICK: 'SLOT_SUB_TERMS_AND_CONDITIONS_CLICK',
  SLOT_SUB_FAQ_CLICK: 'SLOT_SUB_FAQ_CLICK',
  SLOT_SUB_RESERVE_REGULAR_DELIVERY_ENTRY: 'SLOT_SUB_RESERVE_REGULAR_DELIVERY_ENTRY',
  SLOT_SUB_MOBILE_NUMBER_ERROR: 'SLOT_SUB_MOBILE_NUMBER_ERROR',
  SLOT_SUB_ADDRESS_CHANGED: 'SLOT_SUB_ADDRESS_CHANGED',
  SLOT_SUB_MANAGE_ADDRESSES_CLICKED: 'SLOT_SUB_MANAGE_ADDRESSES_CLICKED',
  SLOT_SUB_ADDRESS_CONFIRMATION: 'SLOT_SUB_ADDRESS_CONFIRMATION',
  SLOT_SUB_SELECTED_DAY: 'SLOT_SUB_SELECTED_DAY',
  SLOT_SUB_FREQUENCY_CONFIRMATION: 'SLOT_SUB_FREQUENCY_CONFIRMATION',
  SLOT_SUB_SLOT_CONFIRMATION: 'SLOT_SUB_SLOT_CONFIRMATION',
  SLOT_SUB_ITEMS_CONFIRMATION: 'SLOT_SUB_ITEMS_CONFIRMATION',
  SLOT_SUB_FINAL_CONFIRMATION: 'SLOT_SUB_FINAL_CONFIRMATION',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_TAB: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_TAB',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_MY_ACCOUNT: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_MY_ACCOUNT',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_ORDERS: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_ORDERS',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_SHOPPING_LISTS: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_SHOPPING_LISTS',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_FAVOURITES: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_FAVOURITES',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_ACCOUNT_SETTINGS: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_ACCOUNT_SETTINGS',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_MOBILE_NAV: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_MOBILE_NAV',
  SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_OTHER: 'SLOT_SUB_RESPONSIVE_HOME_PAGE_FROM_OTHER',
  SLOT_SUB_RESPONSIVE_SIGN_UP_PAGE_SCROLL: 'SLOT_SUB_RESPONSIVE_SIGN_UP_PAGE_SCROLL',
  SLOT_SUB_RESPONSIVE_TRY_IT_NOW_TOP_BUTTON: 'SLOT_SUB_RESPONSIVE_TRY_IT_NOW_TOP_BUTTON',
  SLOT_SUB_RESPONSIVE_TRY_IT_NOW_BOTTOM_BUTTON: 'SLOT_SUB_RESPONSIVE_TRY_IT_NOW_BOTTOM_BUTTON',
  SLOT_SUB_RESPONSIVE_TERMS_AND_CONDITIONS_CLICK: 'SLOT_SUB_RESPONSIVE_TERMS_AND_CONDITIONS_CLICK',
  SLOT_SUB_RESPONSIVE_FAQ_CLICK: 'SLOT_SUB_RESPONSIVE_FAQ_CLICK',
  SLOT_SUB_RESPONSIVE_ADDRESS_CHANGED: 'SLOT_SUB_RESPONSIVE_ADDRESS_CHANGED',
  SLOT_SUB_RESPONSIVE_MANAGE_ADDRESSES_CLICKED: 'SLOT_SUB_RESPONSIVE_MANAGE_ADDRESSES_CLICKED',
  SLOT_SUB_RESPONSIVE_ADDRESS_CONFIRMATION: 'SLOT_SUB_RESPONSIVE_ADDRESS_CONFIRMATION',
  SLOT_SUB_RESPONSIVE_SELECTED_DAY: 'SLOT_SUB_RESPONSIVE_SELECTED_DAY',
  SLOT_SUB_RESPONSIVE_FREQUENCY_CONFIRMATION: 'SLOT_SUB_RESPONSIVE_FREQUENCY_CONFIRMATION',
  SLOT_SUB_RESPONSIVE_SLOT_CONFIRMATION: 'SLOT_SUB_RESPONSIVE_SLOT_CONFIRMATION',
  SLOT_SUB_RESPONSIVE_ITEMS_CONFIRMATION: 'SLOT_SUB_RESPONSIVE_ITEMS_CONFIRMATION',
  SLOT_SUB_RESPONSIVE_SEE_SMS_REMINDERS: 'SLOT_SUB_RESPONSIVE_SEE_SMS_REMINDERS',
  SLOT_SUB_RESPONSIVE_MOBILE_NUMBER_CONFIRMATION: 'SLOT_SUB_RESPONSIVE_MOBILE_NUMBER_CONFIRMATION',
  SLOT_SUB_RESPONSIVE_MOBILE_NUMBER_ERROR: 'SLOT_SUB_RESPONSIVE_MOBILE_NUMBER_ERROR',
  SLOT_SUB_RESPONSIVE_FINAL_CONFIRMATION: 'SLOT_SUB_RESPONSIVE_FINAL_CONFIRMATION',
  SLOT_SUB_LAND_ON_PAYMENT_PAGE: 'SLOT_SUB_LAND_ON_PAYMENT_PAGE',
  SLOT_SUB_PAYPAL_TOKEN_SELECTED: 'SLOT_SUB_PAYPAL_TOKEN_SELECTED',
  SLOT_SUB_CREDIT_CARD_TOKEN_SELECTED: 'SLOT_SUB_CREDIT_CARD_TOKEN_SELECTED',
  SLOT_SUB_PROBLEM_ORDERS_ENTRY: 'SLOT_SUB_PROBLEM_ORDERS_ENTRY',
  SLOT_SUB_UNAVAILABLE_ITEMS: 'SLOT_SUB_UNAVAILABLE_ITEMS',
  SLOT_SUB_SUCCESS_SIGN_UP: 'SLOT_SUB_SUCCESS_SIGN_UP',
  FOP_VIEW_PREFERENCE_SWITCHED: 'FOP_VIEW_PREFERENCE_SWITCHED',
  SUBSCRIPTIONS_QUANTITY: 'SUBSCRIPTIONS_QUANTITY',
  SUBSCRIPTIONS_FREQUENCY: 'SUBSCRIPTIONS_FREQUENCY',
  SUBSCRIPTIONS_ADD_PRODUCT: 'SUBSCRIPTIONS_ADD_PRODUCT',
  SUBSCRIPTIONS_RESET: 'Subscriptions Reset button clicked',
  RECOMMENDATIONS_POPUP_SHOWN: 'RECOMMENDATIONS_POPUP_SHOWN',
  RECOMMENDATIONS_QUANTITY: 'RECOMMENDATIONS_QUANTITY',
  RECOMMENDATIONS_FREQUENCY: 'RECOMMENDATIONS_FREQUENCY',
  RECOMMENDATIONS_ADD_PRODUCT: 'RECOMMENDATIONS_ADD_PRODUCT',
  RECOMMENDATIONS_NO_SHOW_AGAIN_CLICKED: 'RECOMMENDATIONS_NO_SHOW_AGAIN_CLICKED',
  WINDOW_RESIZE: 'WINDOW_RESIZE',

  // Orders Reserved
  OR_HOW_TO_JOIN_CLICKED: 'OR_HOW_TO_JOIN_CLICKED',
  OR_CHOOSE_YOUR_SLOT_TOP_CLICKED: 'OR_CHOOSE_YOUR_SLOT_TOP_CLICKED',
  OR_CHOOSE_YOUR_SLOT_BOTTOM_CLICKED: 'OR_CHOOSE_YOUR_SLOT_BOTTOM_CLICKED',
  OR_ADDRESS_CLICKED: 'OR_ADDRESS_CLICKED',
  OR_PHONE_NUMBER_SUBMITTED: 'OR_PHONE_NUMBER_SUBMITTED',
  OR_PHONE_NUMBER_ERROR: 'OR_PHONE_NUMBER_ERROR',
  OR_FREQUENCY_CLICKED: 'OR_FREQUENCY_CLICKED',
  OR_DAY_CLICKED: 'OR_DAY_CLICKED',
  OR_EXISTING_DELIVERY_POPUP_SHOWN: 'OR_EXISTING_DELIVERY_POPUP_SHOWN',
  OR_TIME_OF_DAY_CLICKED: 'OR_TIME_OF_DAY_CLICKED',
  OR_SLOT_CLICKED: 'OR_SLOT_CLICKED',
  OR_PAYMENT_METHOD_CLICKED: 'OR_PAYMENT_METHOD_CLICKED',
  OR_LOADING_DATA_ERROR: 'OR_LOADING_DATA_ERROR',
  OR_LOADING_DATA_ERROR_TRY_AGAIN: 'OR_LOADING_DATA_ERROR_TRY_AGAIN',
  OR_REGISTRATION_CANCEL_CLICKED: 'OR_REGISTRATION_CANCEL_CLICKED',
  OR_QUIT_REGISTRATION_CONFIRM: 'OR_QUIT_REGISTRATION_CONFIRM',
  OR_QUIT_REGISTRATION_CANCEL: 'OR_QUIT_REGISTRATION_CANCEL',
  OR_REGISTRATION_CONTINUE_CLICKED: 'OR_REGISTRATION_CONTINUE_CLICKED',
  OR_REGISTRATION_SUMMARY_SUCCESS: 'OR_REGISTRATION_SUMMARY_SUCCESS',
  OR_REGISTRATION_SUMMARY_WARNINGS: 'OR_REGISTRATION_SUMMARY_WARNINGS',
  OR_REGISTRATION_SUMMARY_ERROR: 'OR_REGISTRATION_SUMMARY_ERROR',
  OR_REGISTRATION_SUMMARY_ERROR_TRY_AGAIN: 'OR_REGISTRATION_SUMMARY_ERROR_TRY_AGAIN',
  OR_REGISTRATION_SUMMARY_CLOSE_POPUP: 'OR_REGISTRATION_SUMMARY_CLOSE_POPUP',

  // Quick Menu
  QM_OPEN: 'QM_OPEN',
  QM_CLOSE: 'QM_CLOSE',
  QM_ADD_TO_FAVOURITES: 'QM_ADD_TO_FAVOURITES',
  QM_REMOVE_FROM_FAVOURITES: 'QM_REMOVE_FROM_FAVOURITES',
  QM_CREATE_SHOPPING_LIST: 'QM_CREATE_SHOPPING_LIST',
  QM_OPEN_SHOPPING_LIST_POPUP: 'QM_OPEN_SHOPPING_LIST_POPUP',
  QM_CLOSE_SHOPPING_LIST_POPUP: 'QM_CLOSE_SHOPPING_LIST_POPUP',

  // Account settings
  DELIVERY_PREFERENCES_USE_ADDITIONAL_BAGS_VALUE_CHANGED: 'DELIVERY_PREFERENCES_USE_ADDITIONAL_BAGS_VALUE_CHANGED',
  DELIVERY_PREFERENCES_SAVE_BUTTON_CLICKED: 'DELIVERY_PREFERENCES_SAVE_BUTTON_CLICKED',
  DELIVERY_PREFERENCES_SUCCESS_NOTIFICATION_DISPLAYED: 'DELIVERY_PREFERENCES_SUCCESS_NOTIFICATION_DISPLAYED',
  DELIVERY_PREFERENCES_ERROR_NOTIFICATION_DISPLAYED: 'DELIVERY_PREFERENCES_ERROR_NOTIFICATION_DISPLAYED',

  MARKETING_COMMUNICATIONS_OWN_OFFERS_VALUE_CHANGED: 'MARKETING_COMMUNICATIONS_OWN_OFFERS_VALUE_CHANGED',
  MARKETING_COMMUNICATIONS_THIRD_PARTY_OFFERS_VALUE_CHANGED: 'MARKETING_COMMUNICATIONS_THIRD_PARTY_OFFERS_VALUE_CHANGED',
  MARKETING_COMMUNICATIONS_PRIVACY_POLICY_LINK_CLICKED: 'MARKETING_COMMUNICATIONS_PRIVACY_POLICY_LINK_CLICKED',
  MARKETING_COMMUNICATIONS_SAVE_BUTTON_CLICKED: 'MARKETING_COMMUNICATIONS_SAVE_BUTTON_CLICKED',
  MARKETING_COMMUNICATIONS_SUCCESS_NOTIFICATION_DISPLAYED: 'MARKETING_COMMUNICATIONS_SUCCESS_NOTIFICATION_DISPLAYED',
  MARKETING_COMMUNICATIONS_ERROR_NOTIFICATION_DISPLAYED: 'MARKETING_COMMUNICATIONS_ERROR_NOTIFICATION_DISPLAYED',

  CALENDAR_EVENTS_CALENDAR_ATTACHMENTS_VALUE_CHANGED: 'CALENDAR_EVENTS_CALENDAR_ATTACHMENTS_VALUE_CHANGED',
  CALENDAR_EVENTS_SAVE_BUTTON_CLICKED: 'CALENDAR_EVENTS_SAVE_BUTTON_CLICKED',
  CALENDAR_EVENTS_SUCCESS_NOTIFICATION_DISPLAYED: 'CALENDAR_EVENTS_SUCCESS_NOTIFICATION_DISPLAYED',
  CALENDAR_EVENTS_ERROR_NOTIFICATION_DISPLAYED: 'CALENDAR_EVENTS_ERROR_NOTIFICATION_DISPLAYED',

  SKIP_HEALTHIFY_VALUE_CHANGED: 'SKIP_HEALTHIFY_VALUE_CHANGED',
  SKIP_HEALTHIFY_SAVE_BUTTON_CLICKED: 'SKIP_HEALTHIFY_SAVE_BUTTON_CLICKED',
  SKIP_HEALTHIFY_SUCCESS_NOTIFICATION_DISPLAYED: 'SKIP_HEALTHIFY_SUCCESS_NOTIFICATION_DISPLAYED',
  SKIP_HEALTHIFY_ERROR_NOTIFICATION_DISPLAYED: 'SKIP_HEALTHIFY_ERROR_NOTIFICATION_DISPLAYED',

  FACEBOOK_SETTINGS_LINK_BUTTON_CLICKED: 'FACEBOOK_SETTINGS_LINK_BUTTON_CLICKED',
  FACEBOOK_SETTINGS_UNLINK_BUTTON_CLICKED: 'FACEBOOK_SETTINGS_UNLINK_BUTTON_CLICKED',
  FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_DISPLAYED: 'FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_DISPLAYED',
  FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_CONFIRMED: 'FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_CONFIRMED',
  FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_CLOSED: 'FACEBOOK_SETTINGS_ALREADY_LINKED_POPUP_CLOSED',
  FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_DISPLAYED: 'FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_DISPLAYED',
  FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_CONFIRMED: 'FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_CONFIRMED',
  FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_CLOSED: 'FACEBOOK_SETTINGS_NO_PASSWORD_POPUP_CLOSED',
  FACEBOOK_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED: 'FACEBOOK_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED',
  FACEBOOK_SETTINGS_ERROR_NOTIFICATION_DISPLAYED: 'FACEBOOK_SETTINGS_ERROR_NOTIFICATION_DISPLAYED',
  PAYPAL_SETTINGS_LINK_BUTTON_CLICKED: 'PAYPAL_SETTINGS_LINK_BUTTON_CLICKED',
  PAYPAL_SETTINGS_UNLINK_BUTTON_CLICKED: 'PAYPAL_SETTINGS_UNLINK_BUTTON_CLICKED',
  PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_CONFIRMED: 'PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_CONFIRMED',
  PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_CLOSED: 'PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_CLOSED',
  PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_DISPLAYED: 'PAYPAL_SETTINGS_ALREADY_LINKED_POPUP_DISPLAYED',
  PAYPAL_SETTINGS_NO_PASSWORD_POPUP_DISPLAYED: 'PAYPAL_SETTINGS_NO_PASSWORD_POPUP_DISPLAYED',
  PAYPAL_SETTINGS_NO_PASSWORD_POPUP_CONFIRMED: 'PAYPAL_SETTINGS_NO_PASSWORD_POPUP_CONFIRMED',
  PAYPAL_SETTINGS_NO_PASSWORD_POPUP_CLOSED: 'PAYPAL_SETTINGS_NO_PASSWORD_POPUP_CLOSED',
  PAYPAL_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED: 'PAYPAL_SETTINGS_SUCCESS_NOTIFICATION_DISPLAYED',
  PAYPAL_SETTINGS_ERROR_NOTIFICATION_DISPLAYED: 'PAYPAL_SETTINGS_ERROR_NOTIFICATION_DISPLAYED',

  SMS_ALERTS_VALUE_CHANGED: 'SMS_ALERTS_VALUE_CHANGED',
  SMS_ALERTS_SAVE_BUTTON_CLICKED: 'SMS_ALERTS_SAVE_BUTTON_CLICKED',
  SMS_ALERTS_SUCCESS_NOTIFICATION_DISPLAYED: 'SMS_ALERTS_SUCCESS_NOTIFICATION_DISPLAYED',
  SMS_ALERTS_ERROR_NOTIFICATION_DISPLAYED: 'SMS_ALERTS_ERROR_NOTIFICATION_DISPLAYED',
  SMS_ALERTS_MANAGE_NUMBERS_LINK_CLICKED: 'SMS_ALERTS_MANAGE_NUMBERS_LINK_CLICKED',
  SMS_ALERTS_REMOVE_PHONE_NUMBER: 'SMS_ALERTS_REMOVE_PHONE_NUMBER',
  SMS_ALERTS_REMOVE_PHONE_NUMBER_CONFIRMED: 'SMS_ALERTS_REMOVE_PHONE_NUMBER_CONFIRMED',
  SMS_ALERTS_REMOVE_PHONE_NUMBER_CLOSED: 'SMS_ALERTS_REMOVE_PHONE_NUMBER_CLOSED',

  CONTACT_DETAILS_SAVE_BUTTON_CLICKED: 'CONTACT_DETAILS_SAVE_BUTTON_CLICKED',
  CONTACT_DETAILS_MANAGE_YOUR_ADDRESS_BOOK_CLICKED: 'CONTACT_DETAILS_MANAGE_YOUR_ADDRESS_BOOK_CLICKED',
  CONTACT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED: 'CONTACT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED',
  CONTACT_DETAILS_FAILURE_NOTIFICATION_DISPLAYED: 'CONTACT_DETAILS_FAILURE_NOTIFICATION_DISPLAYED',
  CONTACT_DETAILS_CUSTOMER_CHANGED_FIELD: 'CONTACT_DETAILS_CUSTOMER_CHANGED_FIELD',
  CONTACT_DETAILS_USER_VALIDATION_ERROR: 'CONTACT_DETAILS_USER_VALIDATION_ERROR',
};
